import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_CUSTOM_INPUT_TYPE_PREFIX = 'postermywall-custom-input';
/** Legacy PHP form-array name attribute — kept as `custom-input[]` so server-side parsing still groups the values. */
export const CUSTOM_INPUT_BASE_NAME = 'custom-input[]';

export const buildCustomInputType = (index: number): string => `${POSTERMYWALL_CUSTOM_INPUT_TYPE_PREFIX}-${index}`;

export function buildCustomInputComponent(index: number): AddComponentTypeOptions {
  return createBaseInputComponent({
    inputFieldType: buildCustomInputType(index),
    inputName: CUSTOM_INPUT_BASE_NAME,
    dataMarkerAttribute: `data-is-pmw-form-custom-input-${index.toString()}`,
    displayName: 'Custom',
    placeholder: 'Enter your X here',
    style: FORM_INPUT_STYLES,
    isComponentCheck: (el) => el.getAttribute(`data-is-pmw-form-custom-input-${index.toString()}`) !== null,
  });
}
